<template>
  <div class="fill-height">
    <v-sheet tile color="white" class="fill-height" v-show="not_scanned">
      <v-container align="center">
        <v-row justify="center">
          <div class="camera-container" cols="12" lg="4">
            <div class="camera">
              <vue-qr-reader :video-height="video_height"
                             v-on:code-scanned="onDecode" :stopOnScanned="false"/>
            </div>
            <ScanVisitorsInfo style="margin-top: -8px" :rounded="false" :loading="loading"
                              :forecast="coming_next_30_minutes"/>
          </div>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <StoreVisitorsCircular @refresh="loadCurrentlyInStore" :size="200" :loading="loading" :store="store"
                                   :currently_in_store="currently_in_store"
                                   :expired="currently_in_store_expired"/>

          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet tile color="white" class="fill-height" v-if="!not_scanned">
      <v-container align="center">
        <v-row justify="center">
          <v-col cols="12" lg="4">
            <ScanVisitorsInfo :rounded="true" :loading="loading" :forecast="coming_next_30_minutes"/>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <StoreVisitorsCircular @refresh="loadCurrentlyInStore"
                                   :loading="loading"
                                   :store="store"
                                   :size="200"
                                   :currently_in_store="currently_in_store"
                                   :expired="currently_in_store_expired"/>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <div class="title" v-html="scan_text">
            </div>
            <br/>
            <div class="buttons-container">
              <template v-if="validScan">
                <v-btn :loading="loadingState" depressed color="primary" v-if="canEnterStore" @click="recordStoreEnter">
                  Record Store enter
                </v-btn>
                <v-btn :loading="loadingState" depressed color="primary" v-if="canLeaveStore" @click="recordStoreLeave">
                  Record Store leave
                </v-btn>
              </template>
              <v-btn depressed color="secondary" @click="resetScanInfo">Scan Again</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from 'vue-qrcode-reader'
  import StoreTile from "../Stores/StoreTile";
  import {doEnterStore, doLeaveStore} from "../graphql/mutations";
  import {process_api_error} from "@/utils/utils"
  import Vue from 'vue'
  import {listReservations, getReservation} from "../graphql/queries";

  const moment = require('moment-timezone')
  import {RESERVATION_STATUS, determineStatusValue} from "../utils/constants"
  import ScanVisitorsInfo from "../Elements/ScanVisitorsInfo";
  import StoreVisitorsCircular from "../Elements/StoreVisitorsCircular";
  import VueQrReader from 'vue-qr-reader/dist/lib/vue-qr-reader.umd.js';
  import {fetchItemsNextTokenGraphQL} from "@/utils/query_all_utils";

  export default {
    name: "Scan",
    components: {
      VueQrReader,
      StoreVisitorsCircular,
      ScanVisitorsInfo,
      StoreTile,
      QrcodeStream,
      QrcodeDropZone,
      QrcodeCapture
    },
    data: function () {
      return {
        video_height: 360,
        loading: true,
        coming_next_30_minutes: 0,
        scan_info_reservation_id: undefined,
        scan_info_status: undefined,
        scan_info_dt: undefined,
        scan_info_store_id: undefined,
        camera: 'auto',
        scan_info_error: "",
        currently_in_store: 0,
        currently_in_store_expired: 0,
      }
    },
    computed: {
      ...mapGetters(['loadingState', 'getCurrentStore', 'getReservationById', 'getStoreById']),

      not_scanned() {
        return this.scan_info_reservation_id == undefined && this.scan_info_error == ''
      },

      store() {
        return this.getStoreById(this.getCurrentStore)
      },
      canEnterStore() {
        if (this.scan_info_reservation_id && this.scan_info_status == RESERVATION_STATUS.ACTIVE) {
          return true
        }
        return false
      },
      canLeaveStore() {
        if (this.scan_info_reservation_id && this.scan_info_status == RESERVATION_STATUS.IN_STORE) {
          return true
        }
        return false
      },
      validScan() {
        if (this.scan_info_error == "" && this.scan_info_store_id == this.getCurrentStore) {
          if ((this.scan_info_status == RESERVATION_STATUS.ACTIVE) || (this.scan_info_status == RESERVATION_STATUS.IN_STORE)) {
            return true
          }
        }
        return false
      },
      scan_text() {
        if (this.scan_info_error != "") {
          return "<span class=''>" + this.scan_info_error + "</span>"
        }
        if (this.scan_info_status == RESERVATION_STATUS.COMPLETED) {
          return "<span class=''>This qr code have been already used and person left the store</span>"
        }
        if (this.scan_info_status == RESERVATION_STATUS.CANCELLED) {
          return "<span class=''>This qr code have been cancelled</span>"
        }
        if (this.scan_info_status == RESERVATION_STATUS.EXPIRED) {
          return "<span class=''>This qr code have expired</span>"
        }
        if (this.scan_info_status == RESERVATION_STATUS.ACTIVE) {
          return "<span>Visit planned for " + moment.unix(this.scan_info_dt).utc().format("ddd, MMM Do, YYYY, h:mma") + ", user is outside, record user entering the store ?</span>"
        }
        if (this.scan_info_status == RESERVATION_STATUS.IN_STORE) {
          return "<span>User is in the store. Record user leaving?</span>"
        }
      }
    },
    mounted() {
      window.addEventListener(
        "orientationchange",
        this.handleOrientationChange
      );
      this.loadCurrentlyInStore()
    },
    methods: {
      handleOrientationChange() {
        if (window.hasOwnProperty('orientation')) {
          const orientation = window.orientation
          if (orientation === 0 || orientation === 180) {
            this.video_height = 360
          } else if (orientation === 90 || orientation === -90) {
            this.video_height = 240
          }
        } else {
          const orientation = window.screen.orientation.type
          if (orientation === "portrait-primary") {
            this.video_height = 360
          } else if (orientation === "landscape-primary") {
            this.video_height = 240
          }
        }

      },
      onDecode: async function (result) {
        var reservationresponse = await Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getReservation, {id: result}))
        var reservation = reservationresponse.data.getReservation
        if (reservation) {
          if (reservation.store_id == this.getCurrentStore) {
            var store = this.getStoreById(reservation.store_id)
            if (store) {
              this.scan_info_status = determineStatusValue(reservation, store)
              this.scan_info_reservation_id = result
              this.scan_info_dt = reservation.dt
              this.scan_info_error = ""
              this.scan_info_store_id = store.id
              //this.loadCurrentlyInStore()
            } else {
              this.scan_info_error = "Invalid Store"
            }

          } else {
            this.scan_info_error = "The code you scanned is for a different store."
          }
        } else {
          this.scan_info_error = "Scan error, try again"
        }
      },
      resetScanInfo() {
        this.scan_info_error = ""
        this.scan_info_reservation_id = undefined
        this.scan_info_dt = undefined
        this.scan_info_store_id = undefined
        this.camera = "auto"
        //this.loadCurrentlyInStore()
      },
      async loadCurrentlyInStore() {
        var result = await fetchItemsNextTokenGraphQL(listReservations, {
          filter: {
            iscancelled: {eq: 0},
            store_id: {eq: this.getCurrentStore},
            enterdt: {
              between: [moment().add(-1, "day").unix(), moment().add(1, "day").unix()]
            },
          },
          limit: 100000
        })
        var currently_in_store = 0;
        var currently_in_store_expired = 0;
        var coming_next_30_minutes = 0;

        var store = this.getStoreById(this.getCurrentStore)
        for (var el of result) {
          if (!el.leavedt) {
            if (moment.unix(el.enterdt) < moment().add(-300, 'minutes')) {

            } else {
              if (moment.unix(el.enterdt) > moment().add(-store.minutes_before_out, 'minutes')) {
                currently_in_store += 1;
              } else {
                currently_in_store_expired += 1
              }
            }
          }
        }

        var result = await fetchItemsNextTokenGraphQL(listReservations, {
          filter: {
            iscancelled: {eq: 0},
            store_id: {eq: this.getCurrentStore},
            dt: {
              between: [moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).unix(),
                moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(30, 'minute').unix()]
            },
          },
          limit: 100000
        })
        for (var el of result) {
          if (!el.enterdt) {
            coming_next_30_minutes += 1;
          }
        }
        this.coming_next_30_minutes = coming_next_30_minutes
        this.currently_in_store = currently_in_store
        this.currently_in_store_expired = currently_in_store_expired
        this.loading = false;
        return result;
      },
      recordStoreEnter() {
        var enter_time = moment().unix()
        var scan_info = this.scan_info_reservation_id
        this.resetScanInfo()
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doEnterStore, {
          id: scan_info,
          time: enter_time
        }))
          .then((res) => {
            this.loadCurrentlyInStore()
          })
          .catch((e) => {
            process_api_error(`Error entering the store`, e)
          });
      },
      recordStoreLeave() {
        var leave_time = moment().unix()
        var scan_info = this.scan_info_reservation_id
        this.resetScanInfo()

        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doLeaveStore, {
          id: scan_info,
          time: leave_time
        }))
          .then((res) => {
            this.loadCurrentlyInStore()
          })
          .catch((e) => {
            process_api_error(`Error leaving the store`, e)
          });
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .camera-container {
    display: grid;
    grid-template-rows: 1fr auto;

    .camera {
      min-height: 360px;
    }
  }

  .camera {
    /* TODO make it work border-radius: 8px 8px 0 0 ;*/
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .store-visitors {
      margin-top: 6rem;
    }
  }

  .buttons-container {
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/Pages/Scan.vue